export default {
      id: "ic_modal_close_x-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_modal_close_x-usage",
      toString: function () {
        return this.url;
      }
    }